import { ImageType } from './common.types';

interface Props {
  image?: ImageType;
  fm?: string;
  w?: number;
  h?: number;
  r?: number;
  q?: number;
}

export const composeImageUrl = ({ image, fm, w, h, r, q }: Props) => {
  if (!image) {
    return '';
  }
  let { url } = image;
  if (!url) {
    return '';
  }

  /**
   * Quality
   */
  url += `?q=${q || 100}`;

  /**
   * FILE FORMAT (fm)
   * Defaults to webp, except for SVG.
   */
  if (fm) {
    url += `&fm=${fm}`;
  } else {
    if (image.contentType !== 'image/svg+xml') {
      url += `&fm=webp`;
    }
  }

  /**
   * CIRCLE (style.isCircle)
   * As circular image, with square size.
   */
  if (image.style?.isCircle === true) {
    url += `&fit=thumb&w=${w || '500'}&h=${h || '500'}&r=${r || 'max'}`;
    return url;
  }

  /**
   * WIDTH (w)
   */
  if (w) {
    url += `&w=${w}`;
  }

  /**
   * HEIGHT (h)
   */
  if (h && h > 0) {
    url += `&h=${h}`;
  }

  /**
   * FIT
   * Needed when width & height are equal.
   */
  if (h === w) {
    url += '&fit=thumb';
  }

  return url;
};
